/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Shalani Chethana
 * @Date 6/10/2023
 */

import React from 'react';
import { Grid, Typography } from '@mui/material';
import image1 from "../../assets/images/product/pngwing.com-12.png";
import Styles from "./ourStory.module.css";

function OurStory() {
    return (
        <div className={Styles.outerContainer}>

            <Grid container spacing={2}>
                <Grid size={6} item xs={12} md={6} >
                    <Typography className={Styles.topic}>Our Story</Typography>
                    <Typography variant="body2" className={Styles.description}>

                        N-ACH believes that every business has its own Need for Achievement which could be achieving revenue targets, capturing new markets, expanding operations, etc. Achieving these goals in today’s fast-evolving volatile world requires more than just ambition but competitive software solutions with cutting edge technologies. This demands the right strategy, innovation, technology and expert development. That’s where N-ACH come in.
                        <br></br>
                        We, N-ACH team is specialised in Business Process Management (BPM), leveraging state-of-the-art software solutions to streamline operations, enhance efficiency, and deliver an exceptional experience tailored to each business.
                        <br></br>
                        With a business-driven mindset and cutting-edge technological solutions, we empower organisations to navigate challenges, accelerate digital transformation, and unlock new growth opportunities. Our approach integrates environmental sustainability and intelligent software solutions to create lasting value and build meaningful connections with our clients.
                        At N-ACH, we do not just support businesses but we ignite their potential and help them achieve what’s next.
                    </Typography>
                </Grid>
                <Grid size={6} item xs={12} md={6} className={Styles.imageGrid} >
                    <img src={image1} alt="story" />
                </Grid>
            </Grid>
        </div>
    );
}

export default OurStory;

